import React from 'react';
import './styles.scss';
import { Button } from 'antd';

interface LoadingFailedPageProps {
  /** Defined by the loader middleware */
  loaderRetry: () => void;
  error?: Error;
}

const retriedRecentlyDurationMs = 60_000;

const LoadingFailedPage = (props: LoadingFailedPageProps) => {
  let lastRetriedAt: number = Date.now() - 86_400 * 1000;
  if (localStorage.getItem('lastRetriedAt')) {
    const stored = Number(localStorage.getItem('lastRetriedAt'));
    if (isNaN(stored)) {
      localStorage.removeItem('lastRetriedAt');
    } else {
      lastRetriedAt = stored;
    }
  }
  const retriedRecently = lastRetriedAt > Date.now() - retriedRecentlyDurationMs;

  const onRetry = () => {
    if (retriedRecently) {
      /** We clear local storage because in cases where the user's credentials
       * changed, they could be stuck in an infinite loop of retries
       */
      localStorage.clear();
    } else {
      localStorage.setItem('lastRetriedAt', Date.now().toString());
    }
    props.loaderRetry();
  };

  const isDev = window.env.ENV == 'local' || window.env.ENV == 'development';

  return (
    <div className="loading-failed-container">
      <img
        className="spidertracks-logo"
        src="/main/spidertracks-logo.png"
        alt="Spidertracks Logo"
      />
      <div className="error-container">
        We're having trouble loading this page. Refresh your browser or click Retry to try again.
        {isDev && (
          <div className="error-container">
            Error:
            <span>
              {' '}
              <textarea
                style={{
                  padding: '10px',
                  display: 'block',
                  backgroundColor: '#f0f0f0',
                  maxHeight: '300px',
                  width: '100%',
                  resize: 'none'
                }}
                draggable={false}
                readOnly
                rows={6}
              >
                {JSON.stringify(props.error, undefined, 2)}
              </textarea>
            </span>
          </div>
        )}
      </div>
      {retriedRecently && (
        <div className="retry-message">
          It looks like the Retry button did not solve your problem. Clicking Retry again will reset
          this page, requiring you to log in again.
        </div>
      )}
      <Button className="retry-button" onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
};

export default LoadingFailedPage;
